import React from 'react'
import android from "HELPDESK/CommonResources/images/android.svg"
import apple from "HELPDESK/CommonResources/images/apple.svg"

const AppLink = () => {
  return (
    <div className='subContainers workspace-current-modal-mode' style={{ padding: "14px 14px 20px" }}>
      <p style={{ fontSize: "14px", fontWeight: "bold" }}>Download Apps</p>
      <div  style={{ display: "flex",gap:'10px',justifyContent: "space-between",marginTop:"8px"}}>
        <div className='ws-icon-link-color' style={{cursor:"pointer",textAlign:"center",padding:"7px 30px",borderRadius:'8px'}} onClick={()=>window.open("https://apps.apple.com/app/vmedulife/id1606317107","_blank")}>
          <img src={apple} style={{ height:'70px', width: "70px" }} />

          <p>iOS</p>
        </div>

        <div className='ws-icon-link-color' style={{cursor:"pointer",textAlign:"center",padding:"7px 30px",borderRadius:'8px'}} onClick={()=>window.open("https://play.google.com/store/apps/details?id=com.vmedulifeapp&hl=en_IN","_blank")}>
          <img src={android} style={{  height:'70px',width: "70px" }} />
          <p>Android</p>
        </div>

      </div>
    </div>
  )
}

export default AppLink